// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"59":"menu-bar-new","222":"menu-bar","543":"gallery","594":"about","865":"buy","962":"home","964":"menu-group"}[chunkId] + "." + {"59":"bde9dfd8","222":"5ea2dede","543":"6f46946e","594":"4625b695","865":"94aa8a59","962":"b97c81bf","964":"09eb7931"}[chunkId] + ".css";
};